import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoButtonModule, PoContainerModule, PoDialogModule, PoFieldModule, PoLoadingModule, PoModalModule, PoPageModule, PoTableModule } from '@po-ui/ng-components';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login/login.component';
import { PoModalPasswordRecoveryModule, PoPageLoginModule } from '@po-ui/ng-templates';
import { SafeHtmlPipe } from './login/safe-html.pipe';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [LoginComponent, SafeHtmlPipe],
  imports: [
    CommonModule,
    LoginRoutingModule,
    PoFieldModule,
    PoButtonModule,
    FormsModule,
    PoModalPasswordRecoveryModule,
    ReactiveFormsModule,
    PoLoadingModule,
    PoContainerModule,
    PoPageLoginModule,
    PoTableModule,
    PoModalModule,
    HttpClientModule,
    PoDialogModule,
    PoPageModule
  ]
})
export class LoginModule { }
